"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIStepperButton;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UIIconButton = _interopRequireDefault(require("./UIIconButton"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var EXCLUDED_ICON_BUTTON_PROP_NAMES = ['children', 'use', 'truncate', 'truncateStringProps'];
var ICON_NAMES = {
  first: 'first',
  previous: 'left',
  next: 'right',
  last: 'last'
};

function UIStepperButton(_ref) {
  var iconName = _ref.iconName,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["iconName"]);
  return _react.default.createElement(_UIIconButton.default, (0, _extends2.default)({}, rest, {
    use: "tertiary-light"
  }), _react.default.createElement(_UIIcon.default, {
    name: ICON_NAMES[iconName]
  }));
}

UIStepperButton.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UIIconButton.default.propTypes, EXCLUDED_ICON_BUTTON_PROP_NAMES), {
  'aria-label': _propTypes.default.string.isRequired,
  iconName: _propTypes.default.oneOf(Object.keys(ICON_NAMES)).isRequired
});
UIStepperButton.defaultProps = (0, _extends2.default)({}, (0, _omit.default)(_UIIconButton.default.defaultProps, EXCLUDED_ICON_BUTTON_PROP_NAMES));
UIStepperButton.displayName = 'UIStepperButton';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/button/UIStepperButton.js
// module id = 393
// module chunks = 209 210 211 212